module.exports = __webpack_public_path__ + "static/media/add-student.4538e9a5.svg";